import ConfiguracionRepository from "@/services/ConfiguracionRepository"
import Vue from 'vue'


export default {
  namespaced: true,
  state: {
    conceptos: [],
    subConceptos: [],
    listaSubconceptos: [],
    listaTipoMovimientoAnimal: [],
    listaCategoriaAnimal: [],
    listaSubCategoriaAnimal: [],
    listaTipoMovimientoRecategorizacion: [],
    listaParametrosRecategorizacion: [],
    listaMetodoReproduccion: [],
    listaCategoriaReproduccion: [],

  },
  getters: {
    getSubconceptoById: (state) => (idSubconcepto) => {
      return state.listaSubconceptos.find(sub => sub.idSubconcepto === idSubconcepto) || null
    },
    getConceptoBySlug: (state) => (conceptoSlug) => {
      return state.conceptos.find(concepto => concepto.conceptoSlug === conceptoSlug) || {}
    },
    getSubconceptosByConcepto: (state) => (idConcepto) => {
      return state.subConceptos.find(sub => sub.idConcepto === idConcepto) || null
    },
    getConceptoSlugByConcepto: (state) => (idConcepto) => {
      let concepto = state.conceptos.find(concepto => concepto.idConcepto === idConcepto)
      return concepto ? concepto.conceptoSlug : null
    },
    listaFiltradaConceptos: (state, getters) => {
      let lista = []
      state.conceptos.map(concepto => {
        let subs = getters.getSubconceptosByConcepto(concepto.idConcepto)
        if (subs && subs.subConceptos.length !== 0) {
          lista.push(concepto)
        }
      })
      return lista
    },
    getSubconceptosGroupedByConcepto: (state) => {
      let groupedList = []

      groupedList = state.listaCategoriaAnimal.map(categoria => {
        let listaSubPerCategoria = state.listaSubCategoriaAnimal.filter(sub => sub.idCategoriaAnimal === categoria.idCategoriaAnimal)
        return {
          categoria,
          subcategorias: listaSubPerCategoria
        }
      })
      return groupedList
    },
    getConceptoById: (state) => (idConcepto) => {
      return state.conceptos.find(item => item.idConcepto === idConcepto) || { 'nombre': '' }
    },
    getTipoMovimientoByCodigo: (state) => (codigo) => {
      return state.listaTipoMovimientoAnimal.find(tipo => tipo.idTipoMovimientoAnimal === codigo) || null
    },
    getSubcategoriaByIdCategoria: (state) => (idCategoria) => {
      return state.listaSubCategoriaAnimal.filter(sub => sub.idCategoriaAnimal === idCategoria)
    },
    getSubcategoriasDesmamante: (state) => {
      return state.listaSubCategoriaAnimal.filter(sub => sub.nombre.toLowerCase().includes('desm'))
    },
    getParamRecById: (state) => (id) => {
      return state.listaParametrosRecategorizacion.find(param => param.idParametroRecategorizacion === id) || null
    },
    getParamRecByTipo: (state) => (idTipo) => {
      return state.listaParametrosRecategorizacion.filter(param => param.idTipoMovimientoAnimal === idTipo)
    }
  },
  mutations: {
    setConceptosList(state, conceptos) {
      state.conceptos = conceptos.map(concepto => {
        concepto.conceptoSlug = Vue.filter('fhSlug')(concepto.nombre)
        return concepto
      })
    },

    clearConceptos(state) {
      state.conceptos = []
    },

    setListaSubConceptos(state, subConceptos) {
      let subs = state.conceptos.map(con => {
        return {
          idConcepto: con.idConcepto,
          subConceptos: subConceptos.filter(sub => sub.idConcepto === con.idConcepto && sub.estado === 1)
        }
      })
      state.subConceptos = subs
      state.listaSubconceptos = subConceptos.filter(sub => sub.estado === 1)
    },

    clearListaSubConceptos(state) {
      state.subConceptos = []
      state.listaSubconceptos = []
    },

    setListaTipoMovimientoAnimal(state, listaTipos) {
      state.listaTipoMovimientoAnimal = listaTipos
    },

    clearListaTipoMovimientoAnimal(state) {
      state.listaTipoMovimientoAnimal = []
    },

    setListaCategoriaAnimal(state, listaCategorias) {
      state.listaCategoriaAnimal = listaCategorias
    },

    clearListaCategoriaAnimal(state) {
      state.listaCategoriaAnimal = []
    },

    setListaSubCategoriaAnimal(state, listaSubCategorias) {
      state.listaSubCategoriaAnimal = listaSubCategorias
      state.listaSubCategoriaAnimal.sort((a, b) => (a.categoriaAnimal.nombre > b.categoriaAnimal.nombre) ? 1 : ((b.categoriaAnimal.nombre > a.categoriaAnimal.nombre) ? -1 : 0))
    },

    clearListaSubCategoriaAnimal(state) {
      state.listaSubCategoriaAnimal = []
    },

    setListaTipoMovimientoRecategorizacion(state, listaTipoMovRec) {
      state.listaTipoMovimientoRecategorizacion = listaTipoMovRec
    },

    clearListaTipoMovimientoRecategorizacion(state) {
      state.listaTipoMovimientoRecategorizacion = []
    },

    setListaParametrosRecategorizacion(state, listaParamRec) {
      state.listaParametrosRecategorizacion = listaParamRec
    },

    clearListaParametrosRecategorizacion(state) {
      state.listaParametrosRecategorizacion = []
    },

    setListaMetodoReproduccion(state, lista) {
      state.listaMetodoReproduccion = lista
    },

    clearListaMetodoReproduccion(state) {
      state.listaMetodoReproduccion = []
    },

    setListaCategoriaReproduccion(state, lista) {
      state.listaCategoriaReproduccion = lista
    },

    clearListaCategoriaReproduccion(state) {
      state.listaCategoriaReproduccion = []
    },
  },
  actions: {
    async fetchListaConceptos({ state, commit }) {
      if (state.conceptos && state.conceptos.length !== 0) {
        return
      }

      let resp = await ConfiguracionRepository.listaConceptos()
      commit('setConceptosList', resp)
    },

    clearListaConceptos({ commit }) {
      commit('clearConceptos')
    },

    async fetchListaSubConceptos({ state, commit }) {
      if (state.subConceptos && state.subConceptos.length !== 0) {
        return
      }

      let resp = await ConfiguracionRepository.listaSubConceptos()
      commit('setListaSubConceptos', resp)
    },

    clearListaSubConceptos({ commit }) {
      commit('clearListaSubConceptos')
    },

    async fetchListaTipoMovimientoAnimal({ state, commit }) {
      if (state.listaTipoMovimientoAnimal && state.listaTipoMovimientoAnimal.length !== 0) {
        return
      }

      let resp = await ConfiguracionRepository.listaTipoMovimientoAnimal()
      commit('setListaTipoMovimientoAnimal', resp)
    },

    clearListaTipoMovimientoAnimal({ commit }) {
      commit('clearListaTipoMovimientoAnimal')
    },

    async fetchListaCategoriaAnimal({ state, commit }) {
      if (state.listaCategoriaAnimal && state.listaCategoriaAnimal.length !== 0) {
        return
      }

      let resp = await ConfiguracionRepository.listaCategoriaAnimal()
      commit('setListaCategoriaAnimal', resp)
    },

    clearListaCategoriaAnimal({ commit }) {
      commit('clearListaCategoriaAnimal')
    },

    async fetchListaSubCategoriaAnimal({ state, commit }) {
      if (state.listaSubCategoriaAnimal && state.listaSubCategoriaAnimal.length !== 0) {
        return
      }

      let resp = await ConfiguracionRepository.listaSubCategoriaAnimal()
      commit('setListaSubCategoriaAnimal', resp)
    },

    clearListaSubCategoriaAnimal({ commit }) {
      commit('clearListaSubCategoriaAnimal')
    },

    async fetchListaTipoMovimientoRecategorizacion({ state, commit }) {
      if (state.listaTipoMovimientoRecategorizacion && state.listaTipoMovimientoRecategorizacion.length !== 0) {
        return
      }

      let resp = await ConfiguracionRepository.listaTipoMovimientoRecategorizacion()
      commit('setListaTipoMovimientoRecategorizacion', resp)
    },

    clearListaTipoMovimientoRecategorizacion({ commit }) {
      commit('clearListaTipoMovimientoRecategorizacion')
    },

    async fetchListaParametrosRecategorizacion({ state, commit }) {
      if (state.listaParametrosRecategorizacion && state.listaParametrosRecategorizacion.length !== 0) {
        return
      }

      let resp = await ConfiguracionRepository.listaParametrosRecategorizacion()
      commit('setListaParametrosRecategorizacion', resp)
    },

    clearListaParametrosRecategorizacion({ commit }) {
      commit('clearListaParametrosRecategorizacion')
    },

    async fetchListaMetodoReproduccion({ state, commit }) {
      if (state.listaMetodoReproduccion && state.listaMetodoReproduccion.length !== 0) {
        return
      }

      let resp = await ConfiguracionRepository.listaMetodoReproduccion()
      commit('setListaMetodoReproduccion', resp)
    },

    clearListaMetodoReproduccion({ commit }) {
      commit('clearListaMetodoReproduccion')
    },

    async fetchListaCategoriaReproduccion({ state, commit }) {
      if (state.listaCategoriaReproduccion && state.listaCategoriaReproduccion.length !== 0) {
        return
      }

      let resp = await ConfiguracionRepository.listaCategoriaReproduccion()
      commit('setListaCategoriaReproduccion', resp)
    },

    clearListaCategoriaReproduccion({ commit }) {
      commit('clearListaCategoriaReproduccion')
    },
  }
}